export default "__VITE_ASSET__BbDUe1ZB__"